import React from 'react'

const Button = ({ onClick, children, disabled, variant = "primary", classNames }) => {
    const baseStyles = "px-12 py-8 rounded-lg fw-medium transition duration-200";
    const variants = {
        primary: "bg-blue fg-white",
        outline: "border border-gray fg-dark-grey bg-white ",
        ghost: "fg-dark-gray bg-teal",
    };
    return (
        <button onClick={onClick} disabled={disabled} className={`${baseStyles} ${variants[variant]} ${classNames}`}>
            {children}
        </button>
    );
}
export default Button